import React from "react";
import { FiArrowRight, FiCalendar } from "react-icons/fi";

const ICONS = {
  calendar: FiCalendar,
  arrow: FiArrowRight,
};

export default function ContactFooterHero({ eyebrow, titleLines, description, actions, actionsLabel }) {
  return (
    <div className="max-w-[42rem]">
      {eyebrow ? (
        <span className="inline-flex min-h-[1.8rem] items-center rounded-full border border-[rgba(130,148,255,0.22)] bg-[rgba(100,118,255,0.16)] px-[0.7rem] py-[0.3rem] text-[0.72rem] font-bold uppercase tracking-[0.16em] text-[#dfe7ff]">
          {eyebrow}
        </span>
      ) : null}
      <h2
        id="contact-footer-title"
        className={`${eyebrow ? "mt-[1.4rem]" : "mt-0"} text-[clamp(2.6rem,5vw,4.9rem)] font-bold leading-[0.94] tracking-[-0.04em] text-white`}
      >
        {titleLines.map((line) => (
          <span key={line} className="block">
            {line}
          </span>
        ))}
      </h2>
      {description ? (
        <p className="mt-[1.35rem] max-w-[36rem] text-base leading-[1.75] text-[rgba(221,227,238,0.8)]">
          {description}
        </p>
      ) : null}

      <div className="mt-[1.85rem] flex flex-wrap gap-[0.95rem]" aria-label={actionsLabel}>
        {actions.map((action) => {
          const Icon = ICONS[action.icon] ?? FiArrowRight;
          const isPrimary = action.variant === "primary";

          return (
            <a
              key={action.label}
              href={action.href}
              className={`inline-flex min-h-[3.4rem] items-center justify-center gap-[0.7rem] rounded-full px-[1.4rem] text-[0.98rem] font-semibold no-underline transition duration-200 hover:-translate-y-px sm:w-auto ${
                isPrimary
                  ? "bg-[#4285f4] text-white shadow-[0_14px_32px_rgba(66,133,244,0.24)] hover:bg-[#357ae8]"
                  : "border border-[rgba(154,168,214,0.26)] bg-[rgba(18,20,28,0.64)] text-[#eef2ff]"
              } max-sm:w-full`}
            >
              <Icon className="shrink-0" aria-hidden="true" />
              <span>{action.label}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
